import React, { useContext, useEffect, useState } from "react";
import "./viewFirstScreen.css";
import { Link, useLocation, useParams } from "react-router-dom";
// import ChannelBoxProps from "../../Empty_Screen/Channels_List/ChannelBoxProps";
import ChannelBox from "../../Empty_Screen/Channels_List/ChannelBox";
import DeleteChnnelConfir from "../Deleete_confir_channel/DeleteChnnelConfir";
// import ChannelPost from "../Vew_Channel_Post/ChannelPost";
import AboutChannel from "../View_About_Channel/AboutChannel";
import ChannelMember from "../View_Channel_Member/ChannelMember";
import axios from "../../../../axios";
import CreateChannelFirst from "../../Create_channel_screen/CreateChannelFirst";
import CreatePostFirst from "../../../Open_community/Create_Post_screen/CreatePostFirst";
import SinglePostImage from "../../../Open_community/total_community_post/recent_post Img/SinglePostImage";
import SingleChannelRequest from "../View_channel_Requ/SingleChannelRequest";
import { Popup } from "semantic-ui-react";
import { IP } from "../../../../internalServer";
import { useSelector } from "react-redux";
import RequestContext from "../../../Open_community/Create_channel/View_Channel_Screen/View_First_Screen/requestContext";
import HeaderContext from "../../../../HeaderContext";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import assets from "../../../../assets/assets";
import {
  aboutComm,
  engagementHomeSteps,
  feelDetailSteps,
} from "../../../../utils/engagementSteps";
import CommunityTour from "../../../../SidebarHeader/Header/CommunityTour";

const ViewFirstScreen = () => {
  const activeTab = localStorage.getItem("engegamentTab");
  const [active, setActive] = useState("");
  const [clickDelete, setClickDelete] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [clickCreate, setClickCreate] = useState(false);
  const [postRequestCount, setPostRequestCount] = useState(0);
  const [postCreatedCount, setPostCreatedCount] = useState(0);
  const [rejectedPostCount, setRejectedPostCount] = useState(0);
  const [viewFirstInProgress, setViewFirstInProgress] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isPostCreated, setIsPostCreated] = useState(false);
  const [isMemberUpdated, setIsMemberUpdated] = useState(false);
  const [requestedPostCount, setRequestedpostsCount] = useState(0);
  const [editCommunityDetails, setEditCommunityDetails] = useState({
    community_name: null,
    editingMode: false,
    operationDone: false,
    profilePicture: null,
  });
  const [rejectData, setRejectedData] = useState([])
  const { handleProfile } = useContext(HeaderContext);
  const StudentData = JSON.parse(localStorage.getItem("breathForStudent"));


  const { community_name, editingMode, operationDone, profilePicture } =
    editCommunityDetails;
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isOpenedPopup, setIsOpenedPopup] = useState();
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const [comments, setComments] = useState([])
  const [communityPost, setCommunityPost] = useState({
    community: {},
    communitybyID: [],
  });

  const { community, communitybyID } = communityPost;
  const currentUser = useSelector((state) => state.user.currentUser);

  const { state } = useLocation()

  useEffect(() => {
    const clickedTab = activeTab ? activeTab : 'Request';
    setActive(clickedTab)
  }, [activeTab])

  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [steps, setSteps] = useState(aboutComm);
  const onExit = () => {
    setStepsEnabled(false);
  };

  const getCommuntiy = async () => {
    try {
      setSelectedCommunityId(state.communityId);
      // const res = await axios.get(`/community/get/${state.communityId}`);
      const res = await axios.get(`/community/get/${state.communityId}?isFullFledged=true&userId=${currentUser?.id}`);
      const communitybyID = await axios.get(
        `/community/getByUserId/student/${currentUser?.id}`
      );

      res &&
        communitybyID &&
        setCommunityPost({
          community: res.data.data,
          communitybyID: communitybyID.data.data,
        });
      setEditCommunityDetails({
        ...editCommunityDetails,
        community_name: res.data.data.community_name,
      });

      setViewFirstInProgress(false);
      setPostRequestCount(0);
      setRejectedPostCount(0);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCommuntiy();
  }, [state, operationDone, isMemberUpdated]);


  useEffect(() => {
    // setInProgress(true);
    const getRequest = async () => {
      try {
        const postRequest = await axios.get(
          `/community/${state.communityId}/post/getUserPosts/${currentUser?.id}`
        );
        if (postRequest) {
          const NotactiveEntries = postRequest.data.data.filter(entry => entry.status !== 'active');
          const NotDeletedPost = NotactiveEntries.filter((post) => post.isDeleted !== true)
          setRequestedpostsCount(NotDeletedPost.length);
          setRejectedData(NotactiveEntries)
        }
      } catch (error) {
        console.log(error);
      }
    };
    getRequest();
  }, [active, requestedPostCount, community]);


  const handleSubmit = async () => {
    setViewFirstInProgress(true);
    try {
      let res = await axios.put(`/community/update/${community?.id}`, {
        user_id: teacher_id,
        community_name: community_name,
      });

      res &&
        setEditCommunityDetails({
          ...editCommunityDetails,
          operationDone: !operationDone,
          editingMode: !editingMode,
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleProfilePictureChange = async (file) => {
    setViewFirstInProgress(!viewFirstInProgress);
    let profile_picture = file;
    try {
      if (file) {
        const formData = new FormData();
        formData.append("name", file.name);
        formData.append("uploadCommunityAttachment", file);
        try {
          const res = await axios.post(
            `/community/uploadAttachment/teacherId/${teacher_id}`,
            formData
          );
          profile_picture = res.data.data;
        } catch (error) {
          console.log(error);
        }
      }
      let res = await axios.put(`/community/update/${community?.id}`, {
        user_id: teacher_id,
        profile_picture,
      });
      res &&
        setEditCommunityDetails({
          ...editCommunityDetails,
          operationDone: !operationDone,
        });
      setViewFirstInProgress(!viewFirstInProgress);
    } catch (error) {
      console.log(error);
    }
  };

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg)$/i;
    if (
      !allowedExtensions.exec(filePath.name) ||
      filePath.size > 10 * 1024 * 1024
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPostCreated(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [isPostCreated]);

  return community && community.community_name ? (
    <div>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div
        className="w-100 flex gap-3 overflow-hidden"
        style={{ height: "calc(100vh - 180px)" }}
      >
        <div
          className="flex flex-column gap-1"
          style={{
            width: "70%",
            height: "100%",
            backgroundColor: "white",
            overflow: "hidden",
          }}
        >
          <div className="HeaderDetailContainer d-flex justify-content-between mb-1">
            <div className="d-flex gap-3 align-items-center">
              <Link className="link flex" to="/EngagementCommunity">
                <img src="/images/Back Arrow.svg" alt=""></img>
                <span className="published_hw_file_path1">
                  &nbsp; Community Posts &nbsp;
                </span>
              </Link>
              {/* <div className="HeaderTitle" style={{ cursor: "pointer" }}>
                Community
              </div> */}
            </div>
          </div>
          {viewFirstInProgress && (
            <div className="cover_page_loader">
              <img className=" Loader" src="/gif/LoaderDot.gif" alt="" />
            </div>
          )}
          <div className="gap-3 d-flex align-items-center view_channel_headerBox channelProfile">
            <div className="uploadImg_container">
              <img
                src={`${profilePicture
                  ? URL.createObjectURL(profilePicture)
                  : community?.profile_picture
                    ? `${IP}${community.profile_picture}`
                    : assets.CommunityImg
                  }`}
                className="uploadImage view_first_upload_image"
                alt="uploadimg"
                onError={(e) => {
                  e.target.src = assets.CommunityImg
                }}
              />

              {/* {!profilePicture && !community?.profile_picture ? (
            <>
              <input
                type="file"
                id="attachFileIcon"
                style={{ display: "none" }}
                onChange={(e) => {
                  setEditCommunityDetails({
                    ...editCommunityDetails,
                    profilePicture: e.target.files[0],
                  });
                  handleProfilePictureChange(e.target.files[0]);
                }}
              />
              <label htmlFor="attachFileIcon">
                <img
                  src="/images/CameraIcon.png"
                  className="cameraIcon"
                  alt="cameraIcon"
                />
              </label>
            </>
          ) : (
            <Popup
              on="click"
              trigger={
                <img
                  onClick={() => setIsOpenedPopup(true)}
                  src="/images/CameraIcon.png"
                  className="cameraIcon"
                  alt="cameraIcon"
                />
              }
              content={
                isOpenedPopup && (
                  <div className="container_threedot">
                    <input
                      type="file"
                      id="attachFile"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        if (validateFileType(e.target.files[0])) {
                          setEditCommunityDetails({
                            ...editCommunityDetails,
                            profilePicture: e.target.files[0],
                          });
                          handleProfilePictureChange(e.target.files[0]);
                          setIsOpenedPopup(false);
                        }
                      }}
                    />
                    <label htmlFor="attachFile">
                      <div className="PopupThreedots">Edit</div>
                    </label>
                    <div
                      onClick={(e) => {
                        setEditCommunityDetails({
                          ...editCommunityDetails,
                          profilePicture: null,
                        });
                        handleProfilePictureChange(null);
                        setIsOpenedPopup(false);
                      }}
                      className="PopupThreedots"
                    >
                      Remove
                    </div>
                  </div>
                )
              }
              position="bottom center"
            />
          )} */}
            </div>

            <div
              className={`${editingMode ? `col-sm-7` : `col-sm-5`
                } channel_information d-flex flex-column`}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="view_channel_name">
                  {community?.community_name}
                </span>
                {/* {community?.role !== "member" && (
                <img
                  className="ml-2"
                  style={{ cursor: "pointer" }}
                  src="/images/editing_pencil.svg"
                  alt=""
                  onClick={() =>
                    setEditCommunityDetails({
                      ...editCommunityDetails,
                      editingMode: !editingMode,
                    })
                  }
                />
              )} */}
              </div>

              <div>
                <span className="view_created_by">
                  Created by {community?.user_id?.name} &nbsp;
                </span>
                {
                  community?.user_id?.id === teacher_id && (
                    <span className="you">{"(you)"}</span>
                  )
                }
              </div>
            </div>
            {isPostCreated && (
              <div className=" p-2 view_post_successfull">
                <img src="/images/Success.png" alt="" />
                <span className="post_successfull_message">
                  Your post has been sent for review
                </span>
              </div>
            )}
          </div>

          <div className="p-0 d-flex align-items-center justify-content-between view_button_container">
            <button
              className={`view_buttons_box ${active === "About" && "aboutActive"} aboutTab`}
              onClick={(e) => {
                setActive("About")
                localStorage.setItem("engegamentTab", "About")
              }}
            >
              About
            </button>
            <div
              className={`d-flex view_buttons_box postTab ${active === "Post" && "aboutActive"
                }`}
              onClick={(e) => {
                setActive("Post")
                localStorage.setItem("engegamentTab", "Post")
              }}
            >
              <span>Posts</span>
              <span className="ml-1">
                (
                {/* {community?.active_post_count + postRequestCount + postCreatedCount} */}
                {community?.active_post_count - community?.active_deleted_post_count_by_other_person}
                )
              </span>
            </div>
            <button
              className={` view_buttons_box membersTab ${active === "Member" && "aboutActive"
                }`}
              onClick={(e) => {
                setActive("Member")
                localStorage.setItem("engegamentTab", "Member")
              }}
            >
              Members
            </button>
            <div
              className={`d-flex view_buttons_box ${active === "Request" && "aboutActive"
                }`}
              onClick={(e) => {
                setActive("Request")
                localStorage.setItem("engegamentTab", "Request")
              }}
            >
              <span className="d-flex myRequests">
                My Requests{" "}
                <span className="ml-1" style={{ color: "#AAAAAA" }}>
                  ({requestedPostCount})
                </span>
              </span>
              <span className="ml-1" style={{ color: "#AAAAAA" }}>

              </span>
            </div>
          </div>

          <div className="mt-2">
            <div className="p-0 m-0 ">
              {active === "About" && (
                <AboutChannel
                  setViewFirstInProgress={setViewFirstInProgress}
                  setEditCommunityDetails={setEditCommunityDetails}
                  editCommunityDetails={editCommunityDetails}
                  community={community}
                />
              )}
              {active === "Post" && community?.active_post_count > 0 ? (
                <div id="single-post-image-scroll" className="view_post_box w-100 orange-scrollBar">
                  <SinglePostImage
                    isPostCreated={isPostCreated}
                    communityId={state.communityId}
                    postId={state.postId}
                  // commentLength={(comments.filter((usecomment) => usecomment.user_id.id === StudentData.id || !usecomment.isDeleted)).length}
                  />
                </div>
              ) : (
                active === "Post" && (
                  <div className="view_no_post_msg mt-3">
                    No posts yet. Be the first one to add a post to community.
                  </div>
                )
              )}
              {/* {click1 && <ChannelPost communityId={communityId} />} */}
              {active === "Member" && (
                <div className="view_member_box orange-scrollBar">
                  <ChannelMember
                    setIsMemberUpdated={setIsMemberUpdated}
                    isMemberUpdated={isMemberUpdated}
                    community={community}
                  />
                </div>
              )}

              {active === "Request" && requestedPostCount > 0 ? (
                <RequestContext.Provider
                  value={{ requestedPostCount, setRequestedpostsCount }}
                >
                  <div id="single-channel-request-scroll" className="view_post_box orange-scrollBar w-full">
                    <SingleChannelRequest
                      setPostRequestCount={setPostRequestCount}
                      setRejectedPostCount={setRejectedPostCount}
                      communityId={state.communityId}
                      setRequestedpostsCount={setRequestedpostsCount}
                      requestedPostCount={requestedPostCount}
                    />
                  </div>
                </RequestContext.Provider>
              ) : (
                active === "Request" && (
                  <div className="view_no_post_msg mt-3">No Any Request Yet.</div>
                )
              )}
            </div>
          </div>

        </div>
        <div
          className="flex flex-column gap-4 px-2 py-[50px]"
          style={{ width: "30%", height: "100%", backgroundColor: "white" }}
        >
          <div className="gap-4 mt-3 d-flex align-items-center justify-content-end view_search_pot_box ">
            <div className=" d-flex justify-content-center  createPost">
              <button
                className="btn btn-primary view_post_btn"
                onClick={(e) => setClickPost(true)}
              >
                Post to community
              </button>
            </div>
          </div>
          <div className=" mt-2">
            <div className="mb-3 py-2 d-flex align-items-center justify-content-between border-b-2 border-gray-300 w-100">
              <span className="channel_header">Channels</span>
            </div>
            <div className="view_channel_boxs YourChannels orange-scrollBar">
              {communitybyID &&
                communitybyID.length > 0 &&
                communitybyID.map((data, idx) => (
                  <ChannelBox
                    key={idx}
                    setViewFirstInProgress={setViewFirstInProgress}
                    postCreatedCount={postCreatedCount}
                    viewFirstInProgress={viewFirstInProgress}
                    postRequestCount={postRequestCount}
                    communityData={data}
                    setActive={setActive}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      {clickDelete && (
        <DeleteChnnelConfir
          setClickDelete={setClickDelete}
          communityId={state.communityId}
          community={community}
        />
      )}
      {clickCreate && <CreateChannelFirst change={setClickCreate} />}
      {clickPost && (
        <CreatePostFirst
          clickPost={clickPost}
          isInsideOfCommunity={true}
          setClickPost={setClickPost}
          communityData={community}
          setIsPostCreated={setIsPostCreated}
          setPostCreatedCount={setPostCreatedCount}
        />
      )}
      {homeScreenWalkThroughPopup && (
        <CommunityTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
    </div>
  ) : (
    <>
      <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
    </>
  );
};

export default ViewFirstScreen;
